import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _defineProperty from "/home/ubuntu/Local-Stitch-Front/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/home/ubuntu/Local-Stitch-Front/node_modules/@babel/runtime/regenerator";
import _toConsumableArray from "/home/ubuntu/Local-Stitch-Front/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/home/ubuntu/Local-Stitch-Front/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/home/ubuntu/Local-Stitch-Front/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { GetAllBranchesAPI } from 'api/space';
import { PostCommunityImage, PostCommunityPost } from 'api/community';
import { makeAuthorizationConfig } from 'utils';
import { useCookies } from 'react-cookie';
import { getDistanceFromLatLonInKm } from 'utils/geocoder';
import { Spinner } from 'components/common/Spinner';

var ModalAddNewFeed = function ModalAddNewFeed(_ref) {
  var closeModal = _ref.closeModal;

  var _useCookies = useCookies(),
      _useCookies2 = _slicedToArray(_useCookies, 1),
      cookies = _useCookies2[0];

  var _useState = useState(''),
      content = _useState[0],
      setContent = _useState[1];

  var _useState2 = useState([]),
      images = _useState2[0],
      setImages = _useState2[1];

  var _useState3 = useState([]),
      branches = _useState3[0],
      setBranches = _useState3[1];

  var _useState4 = useState(null),
      selectedBranch = _useState4[0],
      setSelectedBranch = _useState4[1];

  var _useState5 = useState(false),
      isSelectBoxShown = _useState5[0],
      setSelectBoxShown = _useState5[1];

  var _useState6 = useState(true),
      isLoading = _useState6[0],
      setLoading = _useState6[1];

  var checkLimit = function checkLimit(e) {
    if (images.length >= 5) {
      alert('사진 업로드는 최대 5장까지만 가능합니다.');
      e.preventDefault();
    }
  };

  var handleImageUpload = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var files, limit, _loop, i;

      return _regeneratorRuntime.wrap(function _callee$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              files = e.target.files;

              if (!(images.length >= 5)) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return");

            case 3:
              if (images.length + files.length > 5) {
                limit = 5 - images.length;
              } else {
                limit = files.length;
              }

              _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop(i) {
                var formData, res;
                return _regeneratorRuntime.wrap(function _loop$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        formData = new FormData();
                        formData.append('image', files[i]);
                        _context.next = 4;
                        return PostCommunityImage(formData);

                      case 4:
                        res = _context.sent;
                        setImages(function (prev) {
                          return [].concat(_toConsumableArray(prev), [res.data]);
                        });

                      case 6:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _loop);
              });
              i = 0;

            case 6:
              if (!(i < limit)) {
                _context2.next = 11;
                break;
              }

              return _context2.delegateYield(_loop(i), "t0", 8);

            case 8:
              i++;
              _context2.next = 6;
              break;

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee);
    }));

    return function handleImageUpload(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var removeImage = function removeImage(targetId) {
    setImages(function (prev) {
      return prev.filter(function (_ref3) {
        var id = _ref3.id;
        return id !== targetId;
      });
    });
  };

  var selectBranch = function selectBranch(branch) {
    setSelectedBranch(branch);
    setSelectBoxShown(false);
  };

  var submit = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var config, result;
      return _regeneratorRuntime.wrap(function _callee2$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(content === '' && images.length === 0)) {
                _context3.next = 3;
                break;
              }

              alert('내용을 입력해주세요.');
              return _context3.abrupt("return");

            case 3:
              if (selectedBranch) {
                _context3.next = 6;
                break;
              }

              alert('지점을 선택해주세요.');
              return _context3.abrupt("return");

            case 6:
              config = makeAuthorizationConfig(cookies.access_token);
              _context3.next = 9;
              return PostCommunityPost({
                content: content,
                branch: selectedBranch.id,
                image_list: images.map(function (_ref5) {
                  var id = _ref5.id;
                  return id;
                })
              }, config);

            case 9:
              result = _context3.sent;

              if (result.status === 201) {
                alert('게시물이 등록되었습니다.');
                window.location.reload();
              } else {
                alert('일시적인 오류로 등록에 실패했습니다.\n다시한번 시도해주세요.');
              }

            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee2);
    }));

    return function submit() {
      return _ref4.apply(this, arguments);
    };
  }();

  useEffect(function () {
    var getDataAndPosition = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _yield$GetAllBranches, data;

        return _regeneratorRuntime.wrap(function _callee5$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return GetAllBranchesAPI();

              case 2:
                _yield$GetAllBranches = _context6.sent;
                data = _yield$GetAllBranches.data;

                if (data.results) {
                  _context6.next = 6;
                  break;
                }

                return _context6.abrupt("return");

              case 6:
                if ('geolocation' in navigator && 'getCurrentPosition' in navigator.geolocation) {
                  navigator.geolocation.getCurrentPosition( /*#__PURE__*/function () {
                    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(position) {
                      var sortedBranches;
                      return _regeneratorRuntime.wrap(function _callee3$(_context4) {
                        while (1) {
                          switch (_context4.prev = _context4.next) {
                            case 0:
                              sortedBranches = data.results.map(function (branch) {
                                return _objectSpread(_objectSpread({}, branch), {}, {
                                  distance: getDistanceFromLatLonInKm(position.coords.latitude, position.coords.longitude, Number(branch.latitude), Number(branch.longitude))
                                });
                              }).sort(function (a, b) {
                                return a.distance - b.distance;
                              });
                              setBranches(sortedBranches);
                              setLoading(false);

                            case 3:
                            case "end":
                              return _context4.stop();
                          }
                        }
                      }, _callee3);
                    }));

                    return function (_x2) {
                      return _ref7.apply(this, arguments);
                    };
                  }(), /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                    return _regeneratorRuntime.wrap(function _callee4$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            setBranches(data.results);
                            setLoading(false);

                          case 2:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee4);
                  })));
                } else {
                  setBranches(data.results);
                  setLoading(false);
                }

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee5);
      }));

      return function getDataAndPosition() {
        return _ref6.apply(this, arguments);
      };
    }();

    getDataAndPosition();
  }, []);

  if (isLoading) {
    return /*#__PURE__*/_jsx("div", {
      className: "dimd-layer",
      children: /*#__PURE__*/_jsx("div", {
        className: "inner big-type",
        children: /*#__PURE__*/_jsxs("section", {
          className: "cnts-write",
          children: [/*#__PURE__*/_jsx(Spinner, {}), /*#__PURE__*/_jsx("button", {
            type: "button",
            className: "btn-close",
            onClick: closeModal,
            children: /*#__PURE__*/_jsx("span", {
              children: "\uD31D\uC5C5 \uB2EB\uAE30"
            })
          })]
        })
      })
    });
  }

  return /*#__PURE__*/_jsx("div", {
    className: "dimd-layer",
    children: /*#__PURE__*/_jsx("div", {
      className: "inner big-type",
      children: /*#__PURE__*/_jsxs("section", {
        className: "cnts-write",
        children: [/*#__PURE__*/_jsx("h1", {
          children: "\uAC8C\uC2DC\uBB3C \uB4F1\uB85D"
        }), /*#__PURE__*/_jsxs("div", {
          className: "form",
          children: [/*#__PURE__*/_jsx("textarea", {
            placeholder: "\uC5EC\uB7EC\uBD84\uC758 \uC774\uC57C\uAE30\uB97C \uB4E4\uB824\uC8FC\uC138\uC694",
            title: "\uC5EC\uB7EC\uBD84\uC758 \uC774\uC57C\uAE30\uB97C \uB4E4\uB824\uC8FC\uC138\uC694",
            onChange: function onChange(_ref9) {
              var value = _ref9.target.value;
              return setContent(value);
            },
            value: content
          }), /*#__PURE__*/_jsxs("div", {
            className: "photo-up",
            children: [images.length > 0 ? /*#__PURE__*/_jsx("ul", {
              children: images.map(function (_ref10) {
                var image = _ref10.image,
                    id = _ref10.id;
                return /*#__PURE__*/_jsxs("li", {
                  children: [/*#__PURE__*/_jsx("span", {
                    style: {
                      backgroundImage: "url(".concat(image, ")")
                    }
                  }), /*#__PURE__*/_jsx("button", {
                    type: "button",
                    onClick: function onClick() {
                      return removeImage(id);
                    },
                    children: /*#__PURE__*/_jsx("span", {
                      children: "\uC0AC\uC9C4 \uC0AD\uC81C"
                    })
                  })]
                }, id);
              })
            }) : /*#__PURE__*/_jsx("p", {
              children: "\uC0AC\uC9C4\uC744 \uB4F1\uB85D\uD574\uC8FC\uC138\uC694 (\uCD5C\uB300 5\uC7A5\uAE4C\uC9C0 \uAC00\uB2A5)"
            }), /*#__PURE__*/_jsxs("div", {
              className: "file-up",
              children: [/*#__PURE__*/_jsx("input", {
                type: "file",
                id: "photoUp",
                onClick: checkLimit,
                onChange: handleImageUpload,
                multiple: true
              }), /*#__PURE__*/_jsx("label", {
                style: {
                  cursor: 'pointer'
                },
                htmlFor: "photoUp",
                children: /*#__PURE__*/_jsx("span", {
                  children: "\uC0AC\uC9C4\uB4F1\uB85D"
                })
              })]
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "cho-spot ".concat(isSelectBoxShown ? 'selected' : ''),
            children: [/*#__PURE__*/_jsx("button", {
              type: "button",
              onClick: function onClick() {
                return setSelectBoxShown(function (v) {
                  return !v;
                });
              },
              children: selectedBranch ? selectedBranch.name : '지점을 선택해주세요 (필수)'
            }), isSelectBoxShown && /*#__PURE__*/_jsx("div", {
              className: "select-w",
              style: {
                maxHeight: 200,
                overflow: 'auto'
              },
              children: /*#__PURE__*/_jsx("ul", {
                children: branches.map(function (branch) {
                  return /*#__PURE__*/_jsx("li", {
                    style: {
                      cursor: 'pointer'
                    },
                    onClick: function onClick() {
                      return selectBranch(branch);
                    },
                    children: /*#__PURE__*/_jsx("a", {
                      children: branch.name
                    })
                  }, branch.name);
                })
              })
            })]
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "ly-btn",
          children: /*#__PURE__*/_jsx(ButtonWrapper, {
            children: /*#__PURE__*/_jsx("a", {
              href: "#",
              onClick: submit,
              children: "\uB4F1\uB85D"
            })
          })
        }), /*#__PURE__*/_jsx("button", {
          type: "button",
          className: "btn-close",
          onClick: closeModal,
          children: /*#__PURE__*/_jsx("span", {
            children: "\uD31D\uC5C5 \uB2EB\uAE30"
          })
        })]
      })
    })
  });
};

var ButtonWrapper = styled.div.withConfig({
  displayName: "ModalAddNewFeed__ButtonWrapper",
  componentId: "sc-1nso67a-0"
})(["flex:1;@media screen and (max-width:786px){margin-bottom:100px;}"]);
export default ModalAddNewFeed;